export function setFullscreenPosition() {
  // const { isVersionsOpen, isFullscreen, isCanvasActive } = this.getRootState()
  const { isVersionsOpen, isFullscreen } = this.getRootState()

  // const Tabs = this.lookup('CanvasNavbar')

  // console.log(isFullscreen)
  // console.log(isVersionsOpen)
  this.variables({
    isFullscreen,
    isVersionsOpen
  }).changed(() => {
     
    let top

    // if (isFullscreen || isVersionsOpen) {
    //   top = 'var(--spacing-Y)'
    //   Tabs?.setNodeStyles?.(Tabs.props?.fadeOut)
    // } else {
    //   top = 'var(--spacing-C)'
    //   Tabs?.setNodeStyles?.(Tabs.props?.fadeIn)
    // }

    this.setNodeStyles({
      Library: { top },
      CanvasPane: { top }
    })
  })
}
